var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticStyle:{"height":"100%"},attrs:{"bordered":false}},[_c('onldf-component',{ref:"onldf",attrs:{"tb-name":_vm.tbName,"data-id":_vm.dataId,"show-footer":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }